import { useEffect, useState } from "react";
import MainCarousel from "../landing-carousel/MainCarousel";
import LandingInstagram from "../landing-instagram/LandingInstagram";
import LandingPartnersCarousel from "../landing-partners/LandingPartnersCarousel";
import ProductTabs from "../landing-products/ProductTabs";
import ShopOurCategories from "../landing-products/ShopOurCategories";
import ShopOurTiles from "../landing-products/ShopOurTiles";
import TrendingSearch from "../landing-products/TrendingSearch";
import StyleAndAdvice from "../landing-products/StyleAndAdvice";

interface Descriptions {
  style_advice_desc?: string;
  knowledge_base_desc?: string;
  blogs_desc?: string;
  tile_trends_desc?: string;
  instagram_desc?: string;
  [key: string]: string | undefined;
}

const Landing = () => {
  const [descriptions, setDescriptions] = useState<Descriptions>({});

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/get-descriptions`)
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data)) {
          const mapped: Descriptions = {};
          data.forEach((item: { setting: string; value: string }) => {
            mapped[item.setting] = item.value;
          });
          setDescriptions(mapped);
        } else {
          // If backend returns already in object form
          setDescriptions(data);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch description:", err);
      });
  }, []);

  return (
    <>
      <MainCarousel />
      <ShopOurCategories />
      <ProductTabs />
      <TrendingSearch />
      <ShopOurTiles />
      <LandingPartnersCarousel />
      <StyleAndAdvice descriptions={descriptions} />
      {/* <LandingProfile /> */}
      <LandingInstagram descriptions={descriptions} />
    </>
  );
};

export default Landing;
